import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
const storytellerLogoUrl = new URL("../assets/storyteller-logo-white.svg", import.meta.url).toString();
const accessCookieName = "nba_live_access";
const accessCookieValue = "granted";
const accessWord = "DUNKS!";
const oneYearInSeconds = 60 * 60 * 24 * 365;
export function hasSiteAccess(cookieHeader) {
    return cookieHeader
        .split(";")
        .map((part) => part.trim())
        .some((part) => part ===
        `${accessCookieName}=${encodeURIComponent(accessCookieValue)}`);
}
export function isCorrectAccessWord(value) {
    return value.trim().toUpperCase() === accessWord;
}
function currentCookieHeader() {
    return typeof document === "undefined" ? "" : document.cookie;
}
function rememberAccess() {
    const secure = typeof window !== "undefined" && window.location.protocol === "https:"
        ? "; Secure"
        : "";
    document.cookie = `${accessCookieName}=${encodeURIComponent(accessCookieValue)}; Max-Age=${oneYearInSeconds}; Path=/; SameSite=Lax${secure}`;
}
export function AccessGate({ children }) {
    const [isGranted, setIsGranted] = useState(() => hasSiteAccess(currentCookieHeader()));
    const [word, setWord] = useState("");
    const [hasError, setHasError] = useState(false);
    if (isGranted) {
        return children;
    }
    function handleSubmit(event) {
        event.preventDefault();
        if (!isCorrectAccessWord(word)) {
            setHasError(true);
            return;
        }
        rememberAccess();
        setIsGranted(true);
    }
    return (_jsx("main", { className: "access-gate", children: _jsxs("section", { "aria-labelledby": "access-gate-title", className: "access-gate__panel", children: [_jsx("img", { alt: "Storyteller", className: "access-gate__wordmark", src: storytellerLogoUrl }), _jsx("p", { className: "access-gate__eyebrow", children: "NBA PULSE EXPLORATION" }), _jsx("h1", { id: "access-gate-title", children: "Enter the access word" }), _jsxs("form", { onSubmit: handleSubmit, children: [_jsx("label", { htmlFor: "access-word", children: "Access word" }), _jsxs("div", { className: "access-gate__entry", children: [_jsx("input", { "aria-describedby": hasError ? "access-word-error" : undefined, "aria-invalid": hasError, autoCapitalize: "characters", autoComplete: "off", autoFocus: true, id: "access-word", onChange: (event) => {
                                        setWord(event.target.value);
                                        setHasError(false);
                                    }, spellCheck: false, type: "password", value: word }), _jsx("button", { type: "submit", children: "Enter" })] }), hasError ? (_jsx("p", { className: "access-gate__error", id: "access-word-error", role: "alert", children: "That access word doesn\u2019t match." })) : null] })] }) }));
}
